var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},[_c('canvas',{ref:"canvas",staticClass:"my-canvas",attrs:{"width":"200","height":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }